module.exports = __webpack_public_path__ + "4578ca7b601bf7f7d640713f378294a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/backgrounds.png
// module id = 1131
// module chunks = 0